import { isUserAccountActive } from "../services/accountStatusService";
import {
  isUserSubscribedToChannel,
  isAddonContent
} from "../utils/subscriptionUtils";
import { i18n, directions } from "../services/i18nService";
import { resolution } from "../config/ui/resolutionConfig";

const CW = "cw";
const WATCHLIST = "watchlist";
const PLAY = "play";
const LISTLIVECHANNELS = "LiveChannels";
const LOCK = "lock";

export default function getTitlesFormattedForCarousels(type = "", titles = []) {

  const {
    applicationState: { userLogged, userAccountStatus, addons },
  } = this.props;
  const customHeight = type === "LiveChannels" && this.state.nameSection !== "live" ?
    resolution.carousel.height?.home?.live
    : type === "LiveChannels" && this.state.nameSection === "live" ?
      resolution.carousel.height?.live?.live : false
  const customWidth = type === "LiveChannels" && this.state.nameSection !== "live" ?
    resolution.carousel.width?.home?.live
    : type === "LiveChannels" && this.state.nameSection === "live" ?
      resolution.carousel.width?.live?.live : false

  const liveStatusIconText= type === "LiveChannels" && i18n.get("pages.livePage.liveCarousel.live");
  const titlesModified = JSON.parse(JSON.stringify(titles));
  const carouselType = type.toLowerCase();
  const isCWCarousel = carouselType === CW || carouselType === WATCHLIST;
  const isListLiveChannels = carouselType === LISTLIVECHANNELS.toLowerCase();
  titlesModified.forEach(title => {
    if (isCWCarousel) {
      title.iconOverlay = PLAY;
    }
    if (customHeight) {
      title.customHeight = customHeight;
      
    }
    if (customWidth) {
      title.customWidth = customWidth;
    }
    if (liveStatusIconText) {
      title.liveStatusIconText = liveStatusIconText;
    }
    if(title){
     title.hasFrenchAudio = title?.hasFrenchAudio ? title?.hasFrenchAudio : getHasFrenchAudio(title);
    }
    if (isListLiveChannels) {
      getIcon(title, userLogged, userAccountStatus, addons);
      getFormatedNextProgram(title);
    }
  });
  return titlesModified;
}

/* Formatting Live carousel Next program */
const getFormatedNextProgram = title => {
  const next = title.next;
  if (next) {
    next.tsStart = getTime(next);
    next.headingTitle = i18n.get("pages.livePage.liveCarousel.upnext");
    title.next = next;
  }
  return title;
};

const getTime = programme => {
  const startTime = new Date(programme.tsStart * 1000);
  let minutes = new Date(startTime).getMinutes();
  minutes = minutes <= 9 ? '0' + minutes : minutes;
  return `${new Date(startTime).getHours()}:${minutes}`;
};

const getIcon = (title, userLogged, userAccountStatus, addons) => {
  if (userLogged) {
    const IconTitle = title;
    if ((!isUserAccountActive(userAccountStatus) && !isAddonContent(title.addonContent)) || (!isUserSubscribedToChannel(addons, title.addonContent))) {
      IconTitle.icon = LOCK;
    }
    return IconTitle;
  }
  return title;
}
const getHasFrenchAudio = (title) => {
    if(title?.hasFrenchAudio) return true;
    if(title?.languages === null || !title?.languages?.length) return false;
    
    let language = (title.languages.includes("fr") || title.languages.includes("French"));
    return title?.languages[0] === 'fr' || title?.languages[0] === "French" || language ? true : false;
  }